var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42188 14.875H10.2656C10.4766 14.875 10.6875 14.6992 10.6875 14.4531V6.85938C10.6875 6.64844 10.4766 6.4375 10.2656 6.4375H9.42188C9.17578 6.4375 9 6.64844 9 6.85938V14.4531C9 14.6992 9.17578 14.875 9.42188 14.875ZM15.1875 3.0625H12.2695L11.0742 1.09375C10.793 0.636719 10.1602 0.25 9.63281 0.25H6.08203C5.55469 0.25 4.92188 0.636719 4.64062 1.09375L3.44531 3.0625H0.5625C0.246094 3.0625 0 3.34375 0 3.625V4.1875C0 4.50391 0.246094 4.75 0.5625 4.75H1.125V16.5625C1.125 17.5117 1.86328 18.25 2.8125 18.25H12.9375C13.8516 18.25 14.625 17.5117 14.625 16.5625V4.75H15.1875C15.4688 4.75 15.75 4.50391 15.75 4.1875V3.625C15.75 3.34375 15.4688 3.0625 15.1875 3.0625ZM6.01172 2.04297C6.04688 2.00781 6.15234 1.9375 6.1875 1.9375H6.22266H9.52734C9.5625 1.9375 9.66797 2.00781 9.70312 2.04297L10.3008 3.0625H5.41406L6.01172 2.04297ZM12.9375 16.5625H2.8125V4.75H12.9375V16.5625ZM5.48438 14.875H6.32812C6.53906 14.875 6.75 14.6992 6.75 14.4531V6.85938C6.75 6.64844 6.53906 6.4375 6.32812 6.4375H5.48438C5.23828 6.4375 5.0625 6.64844 5.0625 6.85938V14.4531C5.0625 14.6992 5.23828 14.875 5.48438 14.875Z",
    fill: "#FF1493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/icDelete.3ad9826f.svg";
export { ForwardRef as ReactComponent };